/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICheckoutCustomerAccountPaymentViewProps } from './citta-checkout-customer-account-payment';
import { IAccountPaymentEditViewForm } from './components/get-account-payment-form-edit-mode';
import { IAccountPaymentSummaryViewForm } from './components/get-account-payment-form-summary-mode';

export const SummaryForm: React.FC<IAccountPaymentSummaryViewForm> = ({
    formProps,
    label,
    paymentAmount,
    addPaymentButton,
    appliedLine,
    customerStatus,
    bottomBorder
    
}) => (
    <Node {...formProps}>
        <>
            <div className='ms-checkout-customer-account__form-summary-wrap'>
                {label} 
                {paymentAmount}
            </div>
            {/* {addPaymentButton} */}
            {/* {appliedLine} */}
            {customerStatus}
            {bottomBorder}
        </>
    </Node>
);

export const EditForm: React.FC<IAccountPaymentEditViewForm> = ({
    formProps,
    inputLabel,
    inputAmount,
    confirmAmount,
    addPaymentButton,
    customerName,
    customerAccountNumber,
    customerSince,
    accountCredit,
    alert,
    accountDetails,
    appliedLine,
    customerStatus,
    bottomBorder
}) => (
    <Node {...formProps}>
        <>
            {/* {customerName} */}
            {/* {customerAccountNumber}
            {customerSince} */}
            {/* {accountCredit} */}
            {accountDetails}
            {/* {inputLabel} */}
            {alert}
            {/* {inputAmount} */}
            {confirmAmount}
            {/* {customerStatus} */}
            {/* {appliedLine? null :addPaymentButton} */}
            {customerStatus}
            {appliedLine}
            {bottomBorder}
        </>
    </Node>
);

const CheckoutCustomerAccountView: React.FC<ICheckoutCustomerAccountPaymentViewProps> = props => {
    const { checkoutCustomerAccount, checkoutErrorRef, summaryView,editView, moduleState, alert} = props;
    return (
        <Module {...checkoutCustomerAccount} ref={checkoutErrorRef}>
            {alert}
            {moduleState.isReady && summaryView && <SummaryForm {...summaryView} />}
            {!moduleState.isReady && editView && <EditForm {...editView} />}
        </Module>
    );
};

export default CheckoutCustomerAccountView;
